"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RECORD_ACTION;
(function (RECORD_ACTION) {
    RECORD_ACTION[RECORD_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    RECORD_ACTION[RECORD_ACTION["ERROR"] = 1] = "ERROR";
    RECORD_ACTION[RECORD_ACTION["NOTIFY"] = 2] = "NOTIFY";
    RECORD_ACTION[RECORD_ACTION["READ"] = 3] = "READ";
    RECORD_ACTION[RECORD_ACTION["READ_RESPONSE"] = 4] = "READ_RESPONSE";
    RECORD_ACTION[RECORD_ACTION["HEAD"] = 5] = "HEAD";
    RECORD_ACTION[RECORD_ACTION["HEAD_RESPONSE"] = 6] = "HEAD_RESPONSE";
    RECORD_ACTION[RECORD_ACTION["HEAD_BULK"] = 7] = "HEAD_BULK";
    RECORD_ACTION[RECORD_ACTION["HEAD_RESPONSE_BULK"] = 8] = "HEAD_RESPONSE_BULK";
    RECORD_ACTION[RECORD_ACTION["DELETE"] = 9] = "DELETE";
    RECORD_ACTION[RECORD_ACTION["DELETE_SUCCESS"] = 10] = "DELETE_SUCCESS";
    RECORD_ACTION[RECORD_ACTION["DELETE_BULK"] = 11] = "DELETE_BULK";
    RECORD_ACTION[RECORD_ACTION["DELETE_BULK_SUCCESS"] = 12] = "DELETE_BULK_SUCCESS";
    RECORD_ACTION[RECORD_ACTION["DELETED"] = 13] = "DELETED";
    RECORD_ACTION[RECORD_ACTION["WRITE_ACKNOWLEDGEMENT"] = 14] = "WRITE_ACKNOWLEDGEMENT";
    RECORD_ACTION[RECORD_ACTION["CREATE"] = 15] = "CREATE";
    RECORD_ACTION[RECORD_ACTION["CREATEANDUPDATE"] = 16] = "CREATEANDUPDATE";
    RECORD_ACTION[RECORD_ACTION["CREATEANDPATCH"] = 17] = "CREATEANDPATCH";
    RECORD_ACTION[RECORD_ACTION["UPDATE"] = 18] = "UPDATE";
    RECORD_ACTION[RECORD_ACTION["PATCH"] = 19] = "PATCH";
    RECORD_ACTION[RECORD_ACTION["ERASE"] = 20] = "ERASE";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIBEANDHEAD"] = 21] = "SUBSCRIBEANDHEAD";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIBEANDREAD"] = 22] = "SUBSCRIBEANDREAD";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIBECREATEANDREAD"] = 23] = "SUBSCRIBECREATEANDREAD";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIBECREATEANDUPDATE"] = 24] = "SUBSCRIBECREATEANDUPDATE";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIBE"] = 25] = "SUBSCRIBE";
    RECORD_ACTION[RECORD_ACTION["UNSUBSCRIBE"] = 26] = "UNSUBSCRIBE";
    RECORD_ACTION[RECORD_ACTION["LISTEN"] = 27] = "LISTEN";
    RECORD_ACTION[RECORD_ACTION["UNLISTEN"] = 28] = "UNLISTEN";
    RECORD_ACTION[RECORD_ACTION["LISTEN_ACCEPT"] = 29] = "LISTEN_ACCEPT";
    RECORD_ACTION[RECORD_ACTION["LISTEN_REJECT"] = 30] = "LISTEN_REJECT";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIPTION_HAS_PROVIDER"] = 31] = "SUBSCRIPTION_HAS_PROVIDER";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIPTION_HAS_NO_PROVIDER"] = 32] = "SUBSCRIPTION_HAS_NO_PROVIDER";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIPTION_FOR_PATTERN_FOUND"] = 33] = "SUBSCRIPTION_FOR_PATTERN_FOUND";
    RECORD_ACTION[RECORD_ACTION["SUBSCRIPTION_FOR_PATTERN_REMOVED"] = 34] = "SUBSCRIPTION_FOR_PATTERN_REMOVED";
    RECORD_ACTION[RECORD_ACTION["CACHE_RETRIEVAL_TIMEOUT"] = 100] = "CACHE_RETRIEVAL_TIMEOUT";
    RECORD_ACTION[RECORD_ACTION["STORAGE_RETRIEVAL_TIMEOUT"] = 101] = "STORAGE_RETRIEVAL_TIMEOUT";
    RECORD_ACTION[RECORD_ACTION["VERSION_EXISTS"] = 102] = "VERSION_EXISTS";
    RECORD_ACTION[RECORD_ACTION["RECORD_LOAD_ERROR"] = 103] = "RECORD_LOAD_ERROR";
    RECORD_ACTION[RECORD_ACTION["RECORD_CREATE_ERROR"] = 104] = "RECORD_CREATE_ERROR";
    RECORD_ACTION[RECORD_ACTION["RECORD_UPDATE_ERROR"] = 105] = "RECORD_UPDATE_ERROR";
    RECORD_ACTION[RECORD_ACTION["RECORD_DELETE_ERROR"] = 106] = "RECORD_DELETE_ERROR";
    RECORD_ACTION[RECORD_ACTION["RECORD_NOT_FOUND"] = 107] = "RECORD_NOT_FOUND";
    RECORD_ACTION[RECORD_ACTION["INVALID_VERSION"] = 108] = "INVALID_VERSION";
    RECORD_ACTION[RECORD_ACTION["INVALID_PATCH_ON_HOTPATH"] = 109] = "INVALID_PATCH_ON_HOTPATH";
    RECORD_ACTION[RECORD_ACTION["INVALID_LISTEN_REGEX"] = 110] = "INVALID_LISTEN_REGEX";
    RECORD_ACTION[RECORD_ACTION["LISTEN_RESPONSE_TIMEOUT"] = 111] = "LISTEN_RESPONSE_TIMEOUT";
    RECORD_ACTION[RECORD_ACTION["LISTEN_UNSUCCESSFUL"] = 112] = "LISTEN_UNSUCCESSFUL";
    RECORD_ACTION[RECORD_ACTION["RECORD_NOTIFY_ERROR"] = 113] = "RECORD_NOTIFY_ERROR";
    RECORD_ACTION[RECORD_ACTION["MESSAGE_PERMISSION_ERROR"] = 114] = "MESSAGE_PERMISSION_ERROR";
    RECORD_ACTION[RECORD_ACTION["MESSAGE_DENIED"] = 115] = "MESSAGE_DENIED";
    RECORD_ACTION[RECORD_ACTION["INVALID_MESSAGE_DATA"] = 116] = "INVALID_MESSAGE_DATA";
    RECORD_ACTION[RECORD_ACTION["MULTIPLE_SUBSCRIPTIONS"] = 117] = "MULTIPLE_SUBSCRIPTIONS";
    RECORD_ACTION[RECORD_ACTION["NOT_SUBSCRIBED"] = 118] = "NOT_SUBSCRIBED";
})(RECORD_ACTION = exports.RECORD_ACTION || (exports.RECORD_ACTION = {}));
//# sourceMappingURL=record.js.map